<template>
    <div class="font-settings font-settings__row-wrapper">
        <span class="font-settings__label mr-8" v-if="label">{{ label }}:</span>
        <DefaultDropdown
            is-flat
            scrollActive
            :colon="false"
            @update="updateProperty('font_family', $event)"
            :active-case="value.font_family"
            :cases="fontFamilyOpt"
            minWidth="none"
        />
        <DefaultDropdown
            is-flat
            scrollActive
            :colon="false"
            @update="updateProperty('font_size', $event)"
            :active-case="value.font_size"
            :cases="fontSizeOpt"
            minWidth="none"
        />
        <DefaultDropdown
            is-flat
            scrollActive
            :colon="false"
            @update="updateProperty('font_weight', $event)"
            :active-case="value.font_weight"
            :cases="fontWeightOpt"
            minWidth="none"
        />
        <DefaultDropdown
            is-flat
            scrollActive
            :colon="false"
            @update="updateProperty('line_height', $event)"
            :active-case="value.line_height"
            :cases="lineHeightOpt"
            minWidth="none"
        />
        <ColorInput
            v-if="colorInput"
            usedColorsMode
            softPalette
            v-model="value.color"
            :absolute="false"
            :marginBottom="0"
            :diameter="20"
        />
        <span class="font-settings__label ml-8" v-if="label && labelRight">{{ label }}</span>
    </div>
</template>

<script>
import DefaultDropdown from "@components/Forms/DefaultDropdown"
import ColorInput from "@components/Builder/components/ColorInput/ColorInput.vue"

export default {
    name: "FontSettings",
    components: {
        DefaultDropdown,
        ColorInput
    },
    props: {
        colorInput: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            required: false
        },
        labelRight: {
            type: Boolean,
            default: false
        },
        labelSize: {
            type: String,
            default: () => "14px"
        },
        value: {
            type: Object,
            required: true
        },
        fontFamilyOpt: {
            type: Array,
            required: false,
            default: () => ["Inter", "Lato", "Arial", "Sans-serif", "Ubuntu"]
        },
        fontSizeOpt: {
            type: Array,
            required: false,
            default: () => ["10px", "12px", "14px", "16px", "18px", "20px"]
        },
        fontWeightOpt: {
            type: Array,
            required: false,
            default: () => ["Regular", "Medium", "Semibold", "Bold"]
        },
        lineHeightOpt: {
            type: Array,
            required: false,
            default: () => ["100%", "140%", "150%", "160%", "170%", "180%"]
        }
    },
    methods: {
        updateProperty(property, value) {
            this.$emit("update:property", property, value)
        }
    }
}
</script>
<style lang="scss" scoped>
.font-settings {
    color: #323030;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22.4px;

    &__row-wrapper {
        display: flex;
        gap: 4px;
    }
}
</style>
